import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Check } from "lucide-react";

const IMG = {
  hero: "https://images.unsplash.com/photo-1563062206-b586e0c0839d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxwb3dlciUyMGNhdGFtYXJhbiUyMGJvYXR8ZW58MHx8fHwxNzkwNTE4MTk3fDA&ixlib=rb-4.1.0&q=85",
  tuna: "https://images.unsplash.com/photo-1697030891256-36a3770cddde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxnaWFudCUyMGJsdWVmaW4lMjB0dW5hJTIwYnJlYWNoaW5nfGVufDB8fHx8MTc5MDUxODE4Nnww&ixlib=rb-4.1.0&q=85",
  pollock: "/species-pollock.jpg",
  bass: "/species-bass.jpg",
  table: "/species-johndory.jpg",
  deck: "https://images.unsplash.com/photo-1605472074915-e1406eda66bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxib2F0JTIwZGVjayUyMGZpc2hpbmd8ZW58MHx8fHwxNzkwNTE4MTk3fDA&ixlib=rb-4.1.0&q=85",
  helm: "https://images.unsplash.com/photo-1789977015650-0b7ae6d5277d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtYXJpbmUlMjBlbGVjdHJvbmljcyUyMHNvbmFyJTIwcmFkYXIlMjBoZWxtfGVufDB8fHx8MTc5MDUxODE4Nnww&ixlib=rb-4.1.0&q=85",
};

const PHONE = "07929834128";
const EMAIL = "shandefishingltd@gmail.com";

export const SiteHeader = () => (
  <header className="border-b border-stone-800 bg-stone-950/90 backdrop-blur sticky top-0 z-40">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
        <img src="/logo.png" alt="Yellowfin logo" className="w-11 h-11 rounded-full border border-stone-700 object-cover" />
        <div>
          <span className="font-bold tracking-tight text-white block text-base leading-none">YELLOWFIN</span>
          <span className="text-xs text-stone-400 uppercase tracking-widest block mt-1">Cougar Cat 10 · Noss on Dart</span>
        </div>
      </Link>
      <nav className="hidden md:flex items-center gap-8 text-xs font-semibold uppercase tracking-wider text-stone-300">
        <a href="/#species" className="hover:text-amber-400 transition-colors">Species & Grounds</a>
        <a href="/#charters" className="hover:text-amber-400 transition-colors">Rates</a>
        <a href="/#vessel" className="hover:text-amber-400 transition-colors">The Cat</a>
        <a href="/#location" className="hover:text-amber-400 transition-colors">Marina & Stay</a>
        <a href="/#specials" className="hover:text-amber-400 transition-colors">Devon McNab</a>
      </nav>
      <div className="flex items-center gap-4">
        <a href={`tel:${PHONE}`} data-testid="header-phone-link" className="hidden sm:inline-block px-4 py-2 text-xs font-bold uppercase tracking-wider bg-stone-800 text-stone-200 border border-stone-700 hover:border-amber-400 rounded transition-colors">{PHONE}</a>
        <Link to="/book" data-testid="header-book-btn" className="px-5 py-2.5 text-xs font-bold uppercase tracking-wider bg-amber-400 text-stone-950 rounded hover:bg-amber-300 transition-colors">Book Date</Link>
      </div>
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer className="bg-stone-950 border-t border-stone-800 py-12 text-stone-400 text-xs">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="Yellowfin logo" className="w-8 h-8 rounded-full border border-stone-700 object-cover" />
        <span className="font-bold text-white uppercase tracking-wider">Yellowfin Charters Ltd</span>
      </div>
      <div className="flex gap-6 uppercase tracking-wider text-[11px]">
        <a href="/#species" className="hover:text-amber-400">Species</a>
        <a href="/#charters" className="hover:text-amber-400">Rates</a>
        <a href="/#vessel" className="hover:text-amber-400">Catamaran</a>
        <a href="/#location" className="hover:text-amber-400">Marina</a>
        <Link to="/book" className="hover:text-amber-400">Book</Link>
      </div>
      <div className="text-stone-400 flex items-center gap-4">
        <span>Noss on Dart Marina, Dartmouth, Devon</span>
        <Link to="/admin/login" data-testid="footer-skipper-login" className="hover:text-amber-400 uppercase tracking-wider text-[11px]">Skipper Login</Link>
      </div>
    </div>
  </footer>
);

const SpeciesCard = ({ tag, title, text, img, testid }) => (
  <div data-testid={testid} className="bg-stone-900 border border-stone-800 rounded-xl p-6 hover:border-amber-500/50 transition-colors">
    <div className="aspect-[16/9] rounded-lg mb-4 overflow-hidden border border-stone-800">
      <img src={img} alt={title} className="w-full h-full object-cover" loading="lazy" />
    </div>
    <div className="text-amber-400 text-xs font-mono uppercase font-bold">{tag}</div>
    <h3 className="text-xl font-bold text-white mt-1">{title}</h3>
    <p className="text-stone-400 text-xs mt-2 leading-relaxed">{text}</p>
  </div>
);

const PriceCard = ({ tag, title, text, price, unit, features, cta, tripId, featured, testid }) => (
  <div data-testid={testid} className={featured
    ? "bg-gradient-to-b from-stone-900 to-stone-950 border-2 border-amber-400 rounded-2xl p-8 flex flex-col justify-between relative shadow-xl"
    : "bg-stone-950 border border-stone-800 rounded-2xl p-8 flex flex-col justify-between"}>
    {featured && (
      <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-amber-400 text-stone-950 text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full">
        Start Point Exclusive
      </div>
    )}
    <div>
      <div className="text-xs uppercase font-mono text-amber-400 font-semibold mb-2">{tag}</div>
      <h3 className="text-2xl font-bold text-white">{title}</h3>
      <p className="text-stone-400 text-xs mt-2">{text}</p>
      <div className="my-6">
        <span className="text-4xl font-extrabold text-white">{price}</span>
        <span className="text-stone-400 text-xs"> / {unit}</span>
      </div>
      <ul className="text-stone-300 text-xs space-y-3 border-t border-stone-800 pt-6">
        {features.map((f) => (
          <li key={f} className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-amber-400 shrink-0" />{f}</li>
        ))}
      </ul>
    </div>
    <Link to={`/book?trip=${tripId}`} data-testid={`${testid}-cta`}
      className={featured
        ? "mt-8 block w-full py-3.5 bg-amber-400 hover:bg-amber-300 text-stone-950 text-center font-black text-xs uppercase tracking-wider rounded transition-colors"
        : "mt-8 block w-full py-3.5 bg-stone-800 hover:bg-stone-700 text-stone-200 text-center font-bold text-xs uppercase tracking-wider rounded border border-stone-700 transition-colors"}>
      {cta}
    </Link>
  </div>
);

export default function Landing() {
  return (
    <div className="min-h-screen bg-stone-900 text-stone-100 antialiased selection:bg-amber-400 selection:text-stone-950" data-testid="landing-page">
      <SiteHeader />

      {/* Hero */}
      <section className="border-b border-stone-800 py-16 lg:py-24 overflow-hidden"
        style={{ background: "radial-gradient(circle at 75% 20%, rgba(217,119,6,0.18), transparent 45%), radial-gradient(circle at 20% 80%, rgba(14,116,144,0.22), transparent 50%), #0c0a09" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-stone-800/80 border border-amber-500/30 rounded text-xs font-medium text-amber-300 mb-6">
                <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
                Cougar Cat 10 · 10 Miles to Start Point Wrecks & Tuna
              </div>
              <h1 className="text-4xl sm:text-6xl font-black tracking-tight text-white leading-tight uppercase mb-6">
                Fastest To The Grounds
              </h1>
              <p className="text-lg sm:text-xl text-stone-300 font-normal leading-relaxed mb-8 max-w-2xl">
                Yellowfin is a brand-new Cougar Cat 10 based at Premier Noss on Dart Marina. With twin-hull speed and deep stability, reach Devon's prime historical wrecks and the South West's most prolific Bluefin Tuna water in minutes, not hours.
              </p>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-10">
                <Link to="/book" data-testid="hero-book-btn" className="px-8 py-4 bg-amber-400 hover:bg-amber-300 text-stone-950 font-bold uppercase tracking-wider text-sm rounded text-center transition-colors">
                  Reserve Charter Date
                </Link>
                <a href="#charters" data-testid="hero-rates-btn" className="px-6 py-4 bg-stone-800 hover:bg-stone-700 text-stone-200 border border-stone-700 font-semibold uppercase tracking-wider text-xs rounded text-center transition-colors">
                  View Wreck & Tuna Rates
                </a>
              </div>
              <div className="grid grid-cols-3 gap-4 border-t border-stone-800 pt-6 text-stone-400 text-xs">
                <div><span className="block text-white font-bold text-sm">10 Miles</span>Start Point Tuna Grounds</div>
                <div><span className="block text-white font-bold text-sm">10-12 Anglers</span>Wreck Fishing Capacity</div>
                <div><span className="block text-white font-bold text-sm">Noss on Dart</span>Luxury Marina Base</div>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="relative rounded-2xl p-2 bg-gradient-to-b from-stone-700 to-stone-900 border border-stone-700/80 shadow-2xl">
                <div className="aspect-[4/5] rounded-xl overflow-hidden relative">
                  <img src={IMG.hero} alt="Cougar Cat 10 power catamaran cutting through the water" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 z-10">
                    <span className="px-2.5 py-1 bg-amber-400/20 border border-amber-400/40 text-amber-300 text-xs font-mono font-bold uppercase rounded">Dartmouth Fleet</span>
                    <p className="text-white text-base font-bold mt-2">Brand New Cougar Cat 10</p>
                    <p className="text-stone-300 text-xs mt-1">Twin hulls provide unrivalled fishing deck space, low roll at anchor, and rapid cruising speed.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Species */}
      <section id="species" className="py-20 border-b border-stone-800 bg-stone-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
            <div>
              <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Inshore & Offshore Target Quarry</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-2">Target Species & 10-Mile Wrecks</h2>
            </div>
            <p className="text-stone-400 text-sm max-w-md mt-4 md:mt-0">
              Historical wartime and commercial shipwrecks lying 10 miles offshore hold trophy specimens, while Start Point welcomes British waters' greatest apex predator.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <SpeciesCard testid="species-tuna" tag="Start Point Apex" title="Giant Bluefin Tuna" img={IMG.tuna}
              text="The most exciting fish in British waters. Explosive surface strikes, relentless stand-up fights, tag-and-release fishing under authorized charter practice." />
            <SpeciesCard testid="species-pollock" tag="10-Mile Wreck Specimen" title="Giant Pollock & Ling" img={IMG.pollock}
              text="Deep-water vertical jigging and live baiting over deep English Channel wrecks. Huge diving power and rod-bending sport all year round." />
            <SpeciesCard testid="species-bass" tag="Tide Rips & Reefs" title="Hard-Fighting Bass" img={IMG.bass}
              text="Lure casting, drift live-baiting, and working the current lines along Dartmouth headlands for solid specimen silver bass." />
            <SpeciesCard testid="species-table" tag="Table Delicacies" title="John Dory & Cod" img={IMG.table}
              text="Exceptional culinary eating species landed fresh from Devon's clean offshore waters for travelling anglers cooking back at local cottages." />
          </div>
        </div>
      </section>

      {/* Charters */}
      <section id="charters" className="py-20 bg-stone-900 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Transparent Rates</span>
            <h2 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mt-2">Wreck & Tuna Charters</h2>
            <p className="text-stone-300 text-sm mt-3">Book full boat charters for your crew or secure individual angler slots. Fully equipped, skippered offshore trips.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <PriceCard testid="rate-wreck" tripId="wreck_day" tag="10-Mile Historical Wrecks" title="Individual Wreck Day"
              text="Target giant pollock, ling, cod, and John Dory over deep South Devon wrecks."
              price="£130" unit="per angler" cta="Book Wreck Seat"
              features={["10 to 12 anglers capacity", "Full day offshore drift & wreck anchor", "Experienced skipper guidance & drift setup", "Depart from Premier Noss on Dart Marina"]} />
            <PriceCard testid="rate-tuna-whole" tripId="tuna_whole" featured tag="Full Boat Tuna Charter" title="Private Bluefin Tuna Day"
              text="Dedicated full-boat expedition chasing monster Bluefin off Start Point."
              price="£1,350" unit="whole boat (4-6 anglers)" cta="Charter Whole Boat"
              features={["Exclusive charter for 4 to 6 anglers", "Heavy stand-up tackle & spreader bars", "Fast transit on Cougar Cat 10", "Incredible team fight & release experience"]} />
            <PriceCard testid="rate-tuna-seat" tripId="tuna_seat" tag="Single Slot Big Game" title="Individual Tuna Seat"
              text="Join a crew of fellow specimen hunters for a shot at a British Bluefin."
              price="£350" unit="per angler" cta="Join Tuna Roster"
              features={["Shared charter with serious anglers", "Rotation on the strike rods", "Skipper coaching on harness & pump", "Full safety briefings & tea on board"]} />
          </div>
        </div>
      </section>

      {/* Vessel */}
      <section id="vessel" className="py-20 bg-stone-950 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-6 order-2 lg:order-1">
              <div className="grid grid-cols-2 gap-4">
                <div className="aspect-square border border-stone-800 rounded-xl overflow-hidden relative">
                  <img src={IMG.deck} alt="Flush fishing deck" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 to-transparent"></div>
                  <div className="absolute inset-0 p-4 flex flex-col justify-between">
                    <span className="text-amber-400 text-xs font-mono">Flush Deck</span>
                    <span className="text-white text-sm font-semibold">360° Walkaround Fishing Space</span>
                  </div>
                </div>
                <div className="aspect-square border border-stone-800 rounded-xl overflow-hidden relative">
                  <img src={IMG.helm} alt="Modern marine electronics at the helm" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 to-transparent"></div>
                  <div className="absolute inset-0 p-4 flex flex-col justify-between">
                    <span className="text-amber-400 text-xs font-mono">Modern Tech</span>
                    <span className="text-white text-sm font-semibold">CHIRP Sonar & Wreck Mapping</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-6 order-1 lg:order-2">
              <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Vessel Architecture</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-2">Brand New Cougar Cat 10</h2>
              <p className="text-stone-300 text-sm mt-4 leading-relaxed">
                Unlike traditional monohulls that roll uncomfortably in sea swells, the Cougar Cat 10's dual-hull design provides an ultra-stable, level platform. That means less fatigue, no sea-sickness roll when drifting over wrecks, and superior speed to reach distant marks ahead of the fleet.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="border-l-2 border-amber-400 pl-4">
                  <div className="text-white font-bold text-base">Twin Hull Stability</div>
                  <div className="text-stone-400 text-xs mt-1">Stands rock-solid on drift over deep wrecks without heavy rolling.</div>
                </div>
                <div className="border-l-2 border-amber-400 pl-4">
                  <div className="text-white font-bold text-base">Rapid Ground Transit</div>
                  <div className="text-stone-400 text-xs mt-1">Maximise lines-in-the-water time with high cruising speed.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Devon McNab */}
      <section id="specials" className="py-20 bg-stone-900 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-stone-950 via-stone-900 to-amber-950/40 border border-amber-500/30 rounded-2xl p-8 sm:p-12">
            <div className="max-w-3xl">
              <span className="px-3 py-1 bg-amber-400/20 border border-amber-400/40 text-amber-300 text-xs font-mono font-bold uppercase rounded">Coming Soon · Exclusive Sporting Package</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-4">The Devon McNab & Stalking Days</h2>
              <p className="text-stone-300 text-sm mt-3 leading-relaxed">
                Coming soon to Yellowfin: the ultimate West Country sporting challenge. Complete the Devon McNab spanning Bass fishing, Bluefin Tuna fishing, deer stalking, and wild bird shooting across Devon's pristine coast and countryside.
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-stone-800 text-xs">
                <div className="text-stone-300 font-semibold">1. Specimen Bass</div>
                <div className="text-stone-300 font-semibold">2. Bluefin Tuna</div>
                <div className="text-stone-300 font-semibold">3. Deer Stalking</div>
                <div className="text-stone-300 font-semibold">4. Wild Bird Shooting</div>
              </div>
              <div className="mt-8">
                <a href="#contact" data-testid="mcnab-enquire-btn" className="inline-block px-6 py-3 bg-stone-800 hover:bg-stone-700 text-amber-300 border border-amber-400/40 text-xs font-bold uppercase tracking-wider rounded transition-colors">
                  Enquire About Coming Soon Packages
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location */}
      <section id="location" className="py-20 bg-stone-950 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-6">
              <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Convenient For Travelling Anglers</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-2">Premier Noss on Dart Marina</h2>
              <p className="text-stone-300 text-sm mt-4 leading-relaxed">
                Kept at the brand-new multimillion pound Noss on Dart marina in Dartmouth, Devon. Surrounded by outstanding riverside restaurants, boutique hotels, and seamless parking, making it the ideal luxury base for anglers visiting Devon for a multi-day fishing break.
              </p>
              <div className="mt-6 space-y-3 text-xs text-stone-300">
                <div className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-amber-400" /> Direct pontoon boarding with dry gear loading</div>
                <div className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-amber-400" /> Superb local seafood dining right in Dartmouth</div>
                <div className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-amber-400" /> 10 miles run to the South West's finest offshore structure</div>
              </div>
            </div>
            <div className="lg:col-span-6">
              <div className="aspect-[16/10] rounded-xl border border-stone-800 bg-gradient-to-tr from-stone-900 via-amber-950/20 to-stone-800 p-6 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <span className="px-3 py-1 bg-stone-950/80 border border-stone-700 text-white text-xs font-mono rounded flex items-center gap-2"><MapPin className="w-3 h-3 text-amber-400" /> Noss on Dart Marina</span>
                  <span className="text-xs text-amber-400 font-mono">Dartmouth, Devon</span>
                </div>
                <div className="text-stone-300 text-xs">
                  <span className="text-white font-bold block mb-1">Berth Location:</span>
                  Premier Marina, Noss on Dart, Dartmouth, Devon
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sister boat */}
      <section id="fleet" className="py-20 bg-stone-900 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-10 items-center bg-stone-950 border border-stone-800 rounded-2xl p-8 sm:p-12">
            <div className="lg:col-span-8">
              <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Also From Our Fleet</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-2">Shande III · Exmouth</h2>
              <p className="text-stone-300 text-sm mt-4 leading-relaxed max-w-2xl">
                We also run Shande III out of Exmouth — home to some of the best bass fishing in the South West. If you're fishing the east side of Lyme Bay or planning a dedicated bass trip, she'll put you right on them.
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <a href="https://shande.co.uk" target="_blank" rel="noopener noreferrer" data-testid="shande-link"
                className="inline-block px-6 py-3.5 bg-amber-400 hover:bg-amber-300 text-stone-950 text-xs font-bold uppercase tracking-wider rounded transition-colors">
                Visit Shande III — shande.co.uk
              </a>
              <div className="text-stone-500 text-[11px] mt-3">Ask the skipper about Exmouth bass trips when you call</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact / booking rail */}
      <section id="contact" className="py-20 bg-stone-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-stone-900 border border-stone-800 rounded-3xl p-8 sm:p-12">
            <div className="text-center max-w-xl mx-auto mb-10">
              <span className="text-amber-400 font-mono text-xs uppercase tracking-widest font-bold">Reserve With Apple Pay & Card</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mt-2">Book Your Charter Date</h2>
              <p className="text-stone-400 text-xs mt-3">Pick your trip and date on the live booking calendar. Instant confirmation — or call the skipper directly for bespoke tides.</p>
            </div>
            <Link to="/book" data-testid="contact-book-btn" className="block w-full py-4 bg-amber-400 hover:bg-amber-300 text-stone-950 font-black text-sm uppercase tracking-wider rounded-lg text-center transition-colors">
              Open Live Booking Calendar
            </Link>
            <div className="text-center text-[11px] text-stone-400 mt-3">We never share your details. Weather cancellations carry full reschedule or refund.</div>
            <div className="mt-10 pt-8 border-t border-stone-800 grid sm:grid-cols-2 gap-6 text-center sm:text-left">
              <div>
                <span className="text-xs text-stone-400 block uppercase">Skipper Phone & Direct Line</span>
                <a href={`tel:${PHONE}`} data-testid="contact-phone-link" className="text-lg font-bold text-white mt-1 flex items-center justify-center sm:justify-start gap-2 hover:text-amber-400 transition-colors"><Phone className="w-4 h-4 text-amber-400" /> {PHONE}</a>
              </div>
              <div>
                <span className="text-xs text-stone-400 block uppercase">Email Booking Desk</span>
                <a href={`mailto:${EMAIL}`} data-testid="contact-email-link" className="text-sm font-bold text-amber-400 mt-1 flex items-center justify-center sm:justify-start gap-2 hover:text-amber-300 transition-colors"><Mail className="w-4 h-4" /> {EMAIL}</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
